import { Box, Button, SvgIcon, Tooltip } from '@mui/material';
import type { FunctionComponent } from 'react';
import WrenchScrewdriverIcon from '@heroicons/react/24/solid/WrenchScrewdriverIcon';
import SparklesIcon from '@heroicons/react/24/solid/SparklesIcon';

const responsiveButtonSx = {
    minWidth: { xs: 40, md: 'auto' },
    minHeight: { xs: 40, md: 'auto' },
    width: { xs: 40, md: 'auto' },
    height: { xs: 40, md: 'auto' },
    px: { xs: 0, md: 2 },
    borderRadius: { xs: '50%', md: 1 },
    justifyContent: { xs: 'center', md: 'flex-start' },
    '& .MuiButton-startIcon': {
        margin: { xs: 0, md: '0 8px 0 0' },
    },
} as const;

export const ToolsAndChangelogButtons: FunctionComponent = () => (
    <>
        <Tooltip title='starjack.Tools'>
            <Button
                id='starjack-tools-button'
                startIcon={
                    <SvgIcon fontSize='small'>
                        <WrenchScrewdriverIcon />
                    </SvgIcon>
                }
                sx={responsiveButtonSx}
            >
                <Box
                    component='span'
                    sx={{ display: { xs: 'none', md: 'inline' } }}
                >
                    starjack.Tools
                </Box>
            </Button>
        </Tooltip>
        <Tooltip title="What's new">
            <Button
                id='changelog-button'
                startIcon={
                    <SvgIcon fontSize='small'>
                        <SparklesIcon />
                    </SvgIcon>
                }
                sx={responsiveButtonSx}
            >
                <Box
                    component='span'
                    sx={{ display: { xs: 'none', md: 'inline' } }}
                >
                    What&apos;s new
                </Box>
            </Button>
        </Tooltip>
    </>
);
